"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    NativeTabsBottomAccessory: null,
    NativeTabsTriggerBadge: null,
    NativeTabsTriggerIcon: null,
    NativeTabsTriggerLabel: null,
    NativeTabsTriggerPromiseIcon: null,
    NativeTabsTriggerVectorIcon: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get NativeTabsBottomAccessory () {
        return NativeTabsBottomAccessory;
    },
    get NativeTabsTriggerBadge () {
        return NativeTabsTriggerBadge;
    },
    get NativeTabsTriggerIcon () {
        return NativeTabsTriggerIcon;
    },
    get NativeTabsTriggerLabel () {
        return NativeTabsTriggerLabel;
    },
    get NativeTabsTriggerPromiseIcon () {
        return NativeTabsTriggerPromiseIcon;
    },
    get NativeTabsTriggerVectorIcon () {
        return NativeTabsTriggerVectorIcon;
    }
});
const _primitives = require("../../primitives");
const NativeTabsTriggerLabel = _primitives.Label;
const NativeTabsTriggerIcon = _primitives.Icon;
const NativeTabsTriggerVectorIcon = _primitives.VectorIcon;
const NativeTabsTriggerPromiseIcon = function NativeTabsTriggerPromiseIcon(props) {
    return null;
};
const NativeTabsTriggerBadge = _primitives.Badge;
const NativeTabsBottomAccessory = ()=>{
    return null;
};

//# sourceMappingURL=elements.js.map
